import { ToolkitPropertyEnum, makeLookup, syntaxFNMA } from '@aloft/toolkit-shared';

import { PropertyPinStatus } from '../components/Tkv2Map/types.ts';

export const getPropertyPinStatus = makeLookup<
  | ToolkitPropertyEnum<'ListingStatusType'>
  | syntaxFNMA.RentalListingStatus
  | 'Subject'
  | 'Subject (ARV)',
  PropertyPinStatus
>({
  cases: [
    [['Active', 'ComingSoon'], 'Active'],
    [['Contract', 'Backup', 'Pending'], 'Pending'],
    ['SettledSale', 'Sold'],
    ['Rented', 'Rented'],
    [['Deleted', 'Cancelled', 'Expired', 'Off-Market', 'Withdrawn'], 'Off-Market'],
    [['Other', 'Unknown'], 'other'],
    ['Subject', 'Subject'],
    ['Subject (ARV)', 'Subject'],
  ],
  default: 'Off-Market',
});
